import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import t from "../Collection.js";
import { castForReferenceSetter as s, referenceSetter as o } from "../collectionUtils.js";
import { HandleOwnerMixin as r } from "../HandleOwner.js";
import "../has.js";
import i from "../Logger.js";
import { isNone as n } from "../maybe.js";
import { property as p } from "../accessorSupport/decorators/property.js";
import "../arrayUtils.js";
import "../accessorSupport/ensureType.js";
import { subclass as l } from "../accessorSupport/decorators/subclass.js";
i.getLogger("esri.core.support.OwningCollection");

var m = /*#__PURE__*/function (_r) {
  _inherits(m, _r);

  var _super = _createSuper(m);

  function m(e) {
    var _this;

    _classCallCheck(this, m);

    _this = _super.call(this, e), _this.handles.add([_this.on("before-add", function (e) {
      n(e.item) && e.preventDefault();
    }), _this.on("after-add", function (e) {
      return _this._own(e.item);
    }), _this.on("after-remove", function (e) {
      return _this._release(e.item);
    })]);
    return _this;
  }

  _createClass(m, [{
    key: "owner",
    get: function get() {
      return this._get("owner");
    },
    set: function set(e) {
      e !== this._get("owner") && (this._releaseAll(), this._set("owner", e), this._ownAll());
    }
  }, {
    key: "_ownAll",
    value: function _ownAll() {
      var _iterator = _createForOfIteratorHelper(this.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e = _step.value;

          this._own(_e);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_releaseAll",
    value: function _releaseAll() {
      var _iterator2 = _createForOfIteratorHelper(this.items),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _e2 = _step2.value;

          this._release(_e2);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "_createNewInstance",
    value: function _createNewInstance(e) {
      return this.itemType ? new (t.ofType(this.itemType.Type))(e) : new t(e);
    }
  }]);

  return m;
}(r(t));

function a(e, t) {
  return {
    type: e,
    cast: s,
    set: function set(s) {
      var r = o(s, this._get(t), e);
      r.owner = this, this._set(t, r);
    }
  };
}

e([p()], m.prototype, "owner", null), m = e([l("esri.core.support.OwningCollection")], m);
export { m as OwningCollection, a as owningCollectionProperty };